import { useEffect, useState } from "react";
import { FaExternalLinkAlt, FaCheckCircle } from "react-icons/fa";
import { Loading } from "../Other/Loading";
import axios from "axios";
const Enquiries = () => {
  const [enquiries, setEnquiries] = useState([]);

 

  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/contact`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setEnquiries(events.Enquire);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);

  return (
    <div className="bg-gradient-to-br from-blue-300 via-blue-100 to-white py-6 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-extrabold text-center  text-gray-800 leading-tight mb-10 border-b-4 border-blue-500 inline-block pb-2">
          Enquiries
        </h2>

        {enquiries.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {enquiries.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 p-6 text-center border border-indigo-100"
              >
                <FaCheckCircle className="text-4xl text-green-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{item.title}</h3>
                <a
                  href={item.link}
                  className="text-indigo-600 hover:underline font-medium flex items-center justify-center gap-2 mt-3"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Know More <FaExternalLinkAlt />
                </a>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 mt-20">
            <Loading />
          </div>
        )}
      </div>
    </div>
  );
};

export default Enquiries;
